import { lazy } from 'react'

export const HeaderV2 = lazy(() => import('./HeaderV2'))
export const Header = lazy(() => import('./Header'))
export { HeaderWithBurger } from './HeaderWithBurger'
